module.exports = __webpack_public_path__ + "__static/site-1783523783704/img/logo_amex.20b03220.svg";